export default "__VITE_ASSET__BKNYuLak__"